import Typography from '@mui/material/Typography';
import React from 'react';

import * as Styled from './survey-option.style';

export type SurveyOptionProps = {
  label: string;
  selected?: boolean;
  onClick: () => void;
};

export const SurveyOption: React.FC<SurveyOptionProps> = ({
  label,
  selected,
  onClick,
}) => (
  <Styled.Option type="button" $selected={selected} onClick={onClick}>
    <Typography variant="body2">{label}</Typography>
  </Styled.Option>
);
